module.exports = __webpack_public_path__ + "img/2.fcbe21be.jpg";